import api from './api';

export const archiveroService = {
  createEscritura: (formData) => api.post('/archivero/escrituras', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  createProtocolizado: (formData) => api.post('/archivero/protocolizados', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getSolicitudes: (params) => api.get('/archivero/solicitudes', { params }),
  updateEstado: (id, estado) => api.patch(`/archivero/solicitudes/${id}/estado`, { estado }),
  descargarDocumento: (id) => api.get(`/archivero/solicitudes/${id}/documento`, { responseType: 'blob' })
};
